import { Model, Attr, HasOne } from 'spraypaint';
import { Legislation, Organisation, User } from '@/api';
import i18n from '@/plugins/vue-i18n';
import ApplicationRecord from '../ApplicationRecord';

export enum ReportStatus {
  'Pending' = 1,
  'Failed' = 2,
  'Successful' = 3,
}

@Model()
export default class InvoiceReport extends ApplicationRecord {
  static jsonapiType = 'invoice-reports';

  static listHeaders() {
    return [
      {
        text: i18n.t('reports.labels.name'),
        value: 'name',
      },
      {
        text: i18n.t('common.labels.created'),
        value: 'created',
      },
      {
        value: 'file',
        width: 64,
      },
    ];
  }

  static scopeFactory() {
    return InvoiceReport.includes([]);
  }

  @Attr() created: string;

  @Attr() modified: string;

  @Attr() status: ReportStatus;

  @Attr() file: string;

  @Attr() notes: string;

  @HasOne() createdBy: User;

  @HasOne() modifiedBy: User;

  @HasOne() organisation: Organisation;

  @HasOne() legislation: Legislation;
}
